const DEFAULT_OPTIONS = {
  icon: `
    <?xml version="1.0" encoding="UTF-8"?>
    <svg width="32px" height="32px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
      <title>icon-location-map</title>
      <desc>Created with Sketch.</desc>
      <defs></defs>
      <g id="Asset" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
        <g id="icon-location-map">
          <g id="Group-2-Copy" transform="translate(5.000000, 0.000000)">
            <path d="M12.329587,29.5536746 C18.3320846,20.5705956 21.3333333,14.2749263 21.3333333,10.6666667 C21.3333333,4.77562934 16.557704,0 10.6666667,0 C4.77562934,0 0,4.77562934 0,10.6666667 C0,14.274927 3.00124993,20.570598 9.0037498,29.5536798 L9.00375749,29.5536747 C9.61743448,30.4720772 10.8594303,30.7191059 11.7778327,30.105429 C11.9961929,29.9595206 12.1836786,29.7720348 12.329587,29.5536746 Z" id="Oval-3" fill="#6A7AFF"></path>
            <circle id="Oval-2" fill="#FFFFFF" cx="10.6666667" cy="10.6666667" r="5.33333333"></circle>
          </g>
        </g>
      </g>
    </svg>
  `,
  size: 32
};

/**
 * Initializer
 *
 * @param {Object} options - Configuration options, defaults to `DEFAULT_OPTIONS`.
 * */
class SVGMarker {
  constructor(options = DEFAULT_OPTIONS) {
    this.options = options;
  }

  /**
   * Get encoded icon url.
   *
   * * @return {Object} - Configuration icon object for Google map.
   * */
  getIcon() {
    return {
      url: `data:image/svg+xml;charset=UTF-8,${encodeURIComponent(this.options.icon.trim())}`,
      size: new google.maps.Size(this.options.size, this.options.size)
    };
  }
}

export default SVGMarker;



// WEBPACK FOOTER //
// ./app/assets/javascripts/components/map/markers/SVGMarker.js